import React, { useState } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import './Footer.css'
import { useDispatch, useSelector } from "react-redux";
import { addToken } from "../../../store/tokens/Action";
import { UserState } from "../../../store/tokens/UserReducer";

function Footer() {

    const token = useSelector<UserState, UserState['tokens']>(
        (state) => state.tokens
    )

    const dispatch = useDispatch()

    dispatch(addToken(token))

    var footerComponent

    if (token !== "") {
        footerComponent =
            <Grid container direction="row" justifyContent="center" alignItems="center">
                <Grid alignItems="center" item xs={12}>
                    <Box className='box1'>
                        <Box paddingTop={1} display="flex" alignItems="center" justifyContent="center">
                            <Typography 
                            variant="h5" 
                            align="center" 
                            gutterBottom 
                            className='siga-nos'>
                                Siga-nos nas redes sociais 
                                </Typography>
                        </Box>

                        <Box display="flex" alignItems="center" justifyContent="center">
                            <a href="https://github.com/MatheusOliveira-1/" target="_blank">
                                <GitHubIcon className="redes" />
                            </a>
                            <a href="https://www.linkedin.com/in/mo-dev/" target="_blank">
                                <LinkedInIcon className="redes" />
                            </a>
                        </Box>
                    </Box>
                    <Box className="box2">
                        <Box paddingTop={1}>
                            <Typography 
                            variant="subtitle2" 
                            align="center" 
                            gutterBottom className='textos'>
                                © 2020 Copyright:
                            </Typography>
                        </Box>

                        <Box >
                            <a target="_blank" href="https://brasil.generation.org" >
                                <Typography 
                                variant="subtitle2" 
                                gutterBottom
                                align="center"
                                className='link-footer'>
                                    brasil.generation.org
                                </Typography>
                            </a>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

    }

    return (
        <>
            {footerComponent}
        </>
    )
}

export default Footer;